function _regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    _regeneratorRuntime =
        function _regeneratorRuntime() {
            return exports;
        };
    var exports = {},
        Op = Object.prototype,
        hasOwn = Op.hasOwnProperty,
        defineProperty =
            Object.defineProperty ||
            function (obj, key, desc) {
                obj[key] = desc.value;
            },
        $Symbol = "function" == typeof Symbol ? Symbol : {},
        iteratorSymbol = $Symbol.iterator || "@@iterator",
        asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
        toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
        return (
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0,
            }),
                obj[key]
        );
    }

    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return (obj[key] = value);
        };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator =
                outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
            generator = Object.create(protoGenerator.prototype),
            context = new Context(tryLocsList || []);
        return (
            defineProperty(generator, "_invoke", {
                value: makeInvokeMethod(innerFn, self, context),
            }),
                generator
        );
    }

    function tryCatch(fn, obj, arg) {
        try {
            return {type: "normal", arg: fn.call(obj, arg)};
        } catch (err) {
            return {type: "throw", arg: err};
        }
    }

    exports.wrap = wrap;
    var ContinueSentinel = {};

    function Generator() {
    }

    function GeneratorFunction() {
    }

    function GeneratorFunctionPrototype() {
    }

    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
        return this;
    });
    var getProto = Object.getPrototypeOf,
        NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype &&
    NativeIteratorPrototype !== Op &&
    hasOwn.call(NativeIteratorPrototype, iteratorSymbol) &&
    (IteratorPrototype = NativeIteratorPrototype);
    var Gp =
        (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
                Object.create(IteratorPrototype));

    function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
            define(prototype, method, function (arg) {
                return this._invoke(method, arg);
            });
        });
    }

    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg,
                    value = result.value;
                return value &&
                "object" == _typeof(value) &&
                hasOwn.call(value, "__await")
                    ? PromiseImpl.resolve(value.__await).then(
                        function (value) {
                            invoke("next", value, resolve, reject);
                        },
                        function (err) {
                            invoke("throw", err, resolve, reject);
                        }
                    )
                    : PromiseImpl.resolve(value).then(
                        function (unwrapped) {
                            (result.value = unwrapped), resolve(result);
                        },
                        function (error) {
                            return invoke("throw", error, resolve, reject);
                        }
                    );
            }
            reject(record.arg);
        }

        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function (resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }

                return (previousPromise = previousPromise
                    ? previousPromise.then(
                        callInvokeWithMethodAndArg,
                        callInvokeWithMethodAndArg
                    )
                    : callInvokeWithMethodAndArg());
            },
        });
    }

    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function (method, arg) {
            if ("executing" === state)
                throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for (context.method = method, context.arg = arg; ;) {
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method)
                    context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state)
                        throw ((state = "completed"), context.arg);
                    context.dispatchException(context.arg);
                } else
                    "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (
                        ((state = context.done ? "completed" : "suspendedYield"),
                        record.arg === ContinueSentinel)
                    )
                        continue;
                    return {value: record.arg, done: context.done};
                }
                "throw" === record.type &&
                ((state = "completed"),
                    (context.method = "throw"),
                    (context.arg = record.arg));
            }
        };
    }

    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method,
            method = delegate.iterator[methodName];
        if (undefined === method)
            return (
                (context.delegate = null),
                ("throw" === methodName &&
                    delegate.iterator["return"] &&
                    ((context.method = "return"),
                        (context.arg = undefined),
                        maybeInvokeDelegate(delegate, context),
                    "throw" === context.method)) ||
                ("return" !== methodName &&
                    ((context.method = "throw"),
                        (context.arg = new TypeError(
                            "The iterator does not provide a '" + methodName + "' method"
                        )))),
                    ContinueSentinel
            );
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type)
            return (
                (context.method = "throw"),
                    (context.arg = record.arg),
                    (context.delegate = null),
                    ContinueSentinel
            );
        var info = record.arg;
        return info
            ? info.done
                ? ((context[delegate.resultName] = info.value),
                    (context.next = delegate.nextLoc),
                "return" !== context.method &&
                ((context.method = "next"), (context.arg = undefined)),
                    (context.delegate = null),
                    ContinueSentinel)
                : info
            : ((context.method = "throw"),
                (context.arg = new TypeError("iterator result is not an object")),
                (context.delegate = null),
                ContinueSentinel);
    }

    function pushTryEntry(locs) {
        var entry = {tryLoc: locs[0]};
        1 in locs && (entry.catchLoc = locs[1]),
        2 in locs && ((entry.finallyLoc = locs[2]), (entry.afterLoc = locs[3])),
            this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
        var record = entry.completion || {};
        (record.type = "normal"), delete record.arg, (entry.completion = record);
    }

    function Context(tryLocsList) {
        (this.tryEntries = [{tryLoc: "root"}]),
            tryLocsList.forEach(pushTryEntry, this),
            this.reset(!0);
    }

    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                        for (; ++i < iterable.length;)
                            if (hasOwn.call(iterable, i))
                                return (next.value = iterable[i]), (next.done = !1), next;
                        return (next.value = undefined), (next.done = !0), next;
                    };
                return (next.next = next);
            }
        }
        return {next: doneResult};
    }

    function doneResult() {
        return {value: undefined, done: !0};
    }

    return (
        (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            defineProperty(Gp, "constructor", {
                value: GeneratorFunctionPrototype,
                configurable: !0,
            }),
            defineProperty(GeneratorFunctionPrototype, "constructor", {
                value: GeneratorFunction,
                configurable: !0,
            }),
            (GeneratorFunction.displayName = define(
                GeneratorFunctionPrototype,
                toStringTagSymbol,
                "GeneratorFunction"
            )),
            (exports.isGeneratorFunction = function (genFun) {
                var ctor = "function" == typeof genFun && genFun.constructor;
                return (
                    !!ctor &&
                    (ctor === GeneratorFunction ||
                        "GeneratorFunction" === (ctor.displayName || ctor.name))
                );
            }),
            (exports.mark = function (genFun) {
                return (
                    Object.setPrototypeOf
                        ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype)
                        : ((genFun.__proto__ = GeneratorFunctionPrototype),
                            define(genFun, toStringTagSymbol, "GeneratorFunction")),
                        (genFun.prototype = Object.create(Gp)),
                        genFun
                );
            }),
            (exports.awrap = function (arg) {
                return {__await: arg};
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
                return this;
            }),
            (exports.AsyncIterator = AsyncIterator),
            (exports.async = function (
                innerFn,
                outerFn,
                self,
                tryLocsList,
                PromiseImpl
            ) {
                void 0 === PromiseImpl && (PromiseImpl = Promise);
                var iter = new AsyncIterator(
                    wrap(innerFn, outerFn, self, tryLocsList),
                    PromiseImpl
                );
                return exports.isGeneratorFunction(outerFn)
                    ? iter
                    : iter.next().then(function (result) {
                        return result.done ? result.value : iter.next();
                    });
            }),
            defineIteratorMethods(Gp),
            define(Gp, toStringTagSymbol, "Generator"),
            define(Gp, iteratorSymbol, function () {
                return this;
            }),
            define(Gp, "toString", function () {
                return "[object Generator]";
            }),
            (exports.keys = function (val) {
                var object = Object(val),
                    keys = [];
                for (var key in object) keys.push(key);
                return (
                    keys.reverse(),
                        function next() {
                            for (; keys.length;) {
                                var key = keys.pop();
                                if (key in object)
                                    return (next.value = key), (next.done = !1), next;
                            }
                            return (next.done = !0), next;
                        }
                );
            }),
            (exports.values = values),
            (Context.prototype = {
                constructor: Context,
                reset: function reset(skipTempReset) {
                    if (
                        ((this.prev = 0),
                            (this.next = 0),
                            (this.sent = this._sent = undefined),
                            (this.done = !1),
                            (this.delegate = null),
                            (this.method = "next"),
                            (this.arg = undefined),
                            this.tryEntries.forEach(resetTryEntry),
                            !skipTempReset)
                    )
                        for (var name in this)
                            "t" === name.charAt(0) &&
                            hasOwn.call(this, name) &&
                            !isNaN(+name.slice(1)) &&
                            (this[name] = undefined);
                },
                stop: function stop() {
                    this.done = !0;
                    var rootRecord = this.tryEntries[0].completion;
                    if ("throw" === rootRecord.type) throw rootRecord.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(exception) {
                    if (this.done) throw exception;
                    var context = this;

                    function handle(loc, caught) {
                        return (
                            (record.type = "throw"),
                                (record.arg = exception),
                                (context.next = loc),
                            caught && ((context.method = "next"), (context.arg = undefined)),
                                !!caught
                        );
                    }

                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i],
                            record = entry.completion;
                        if ("root" === entry.tryLoc) return handle("end");
                        if (entry.tryLoc <= this.prev) {
                            var hasCatch = hasOwn.call(entry, "catchLoc"),
                                hasFinally = hasOwn.call(entry, "finallyLoc");
                            if (hasCatch && hasFinally) {
                                if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                                if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                            } else if (hasCatch) {
                                if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                            } else {
                                if (!hasFinally)
                                    throw new Error("try statement without catch or finally");
                                if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(type, arg) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        if (
                            entry.tryLoc <= this.prev &&
                            hasOwn.call(entry, "finallyLoc") &&
                            this.prev < entry.finallyLoc
                        ) {
                            var finallyEntry = entry;
                            break;
                        }
                    }
                    finallyEntry &&
                    ("break" === type || "continue" === type) &&
                    finallyEntry.tryLoc <= arg &&
                    arg <= finallyEntry.finallyLoc &&
                    (finallyEntry = null);
                    var record = finallyEntry ? finallyEntry.completion : {};
                    return (
                        (record.type = type),
                            (record.arg = arg),
                            finallyEntry
                                ? ((this.method = "next"),
                                    (this.next = finallyEntry.finallyLoc),
                                    ContinueSentinel)
                                : this.complete(record)
                    );
                },
                complete: function complete(record, afterLoc) {
                    if ("throw" === record.type) throw record.arg;
                    return (
                        "break" === record.type || "continue" === record.type
                            ? (this.next = record.arg)
                            : "return" === record.type
                            ? ((this.rval = this.arg = record.arg),
                                (this.method = "return"),
                                (this.next = "end"))
                            : "normal" === record.type && afterLoc && (this.next = afterLoc),
                            ContinueSentinel
                    );
                },
                finish: function finish(finallyLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        if (entry.finallyLoc === finallyLoc)
                            return (
                                this.complete(entry.completion, entry.afterLoc),
                                    resetTryEntry(entry),
                                    ContinueSentinel
                            );
                    }
                },
                catch: function _catch(tryLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        if (entry.tryLoc === tryLoc) {
                            var record = entry.completion;
                            if ("throw" === record.type) {
                                var thrown = record.arg;
                                resetTryEntry(entry);
                            }
                            return thrown;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                    return (
                        (this.delegate = {
                            iterator: values(iterable),
                            resultName: resultName,
                            nextLoc: nextLoc,
                        }),
                        "next" === this.method && (this.arg = undefined),
                            ContinueSentinel
                    );
                },
            }),
            exports
    );
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}

function _asyncToGenerator(fn) {
    return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
        });
    };
}

function _slicedToArray(arr, i) {
    return (
        _arrayWithHoles(arr) ||
        _iterableToArrayLimit(arr, i) ||
        _unsupportedIterableToArray(arr, i) ||
        _nonIterableRest()
    );
}

function _nonIterableRest() {
    throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
}

function _iterableToArrayLimit(arr, i) {
    var _i =
        null == arr
            ? null
            : ("undefined" != typeof Symbol && arr[Symbol.iterator]) ||
            arr["@@iterator"];
    if (null != _i) {
        var _s,
            _e,
            _x,
            _r,
            _arr = [],
            _n = !0,
            _d = !1;
        try {
            if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else
                for (
                    ;
                    !(_n = (_s = _x.call(_i)).done) &&
                    (_arr.push(_s.value), _arr.length !== i);
                    _n = !0
                ) ;
        } catch (err) {
            (_d = !0), (_e = err);
        } finally {
            try {
                if (
                    !_n &&
                    null != _i["return"] &&
                    ((_r = _i["return"]()), Object(_r) !== _r)
                )
                    return;
            } finally {
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}

function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
    var it =
        (typeof Symbol !== "undefined" && o[Symbol.iterator]) || o["@@iterator"];
    if (!it) {
        if (
            Array.isArray(o) ||
            (it = _unsupportedIterableToArray(o)) ||
            (allowArrayLike && o && typeof o.length === "number")
        ) {
            if (it) o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {done: true};
                    return {done: false, value: o[i++]};
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F,
            };
        }
        throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
    }
    var normalCompletion = true,
        didErr = false,
        err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally {
                if (didErr) throw err;
            }
        },
    };
}

function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
}

function _typeof(obj) {
    "@babel/helpers - typeof";
    return (
        (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                }
                : function (obj) {
                    return obj &&
                    "function" == typeof Symbol &&
                    obj.constructor === Symbol &&
                    obj !== Symbol.prototype
                        ? "symbol"
                        : typeof obj;
                }),
            _typeof(obj)
    );
}

(function () {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null,
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(
            event,
            params.bubbles,
            params.cancelable,
            params.detail
        );
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();
$modal = function $modal(options) {
    var _elemModal,
        _eventShowModal,
        _eventHideModal,
        _hiding = false,
        _destroyed = false,
        _animationSpeed = 200;

    function _createModal(options) {
        var elemModal = document.createElement("div"),
            modalTemplate =
                '<div class="modal__backdrop" data-dismiss="modal"><div class="modal__content"><div class="modal__header"><div class="modal__title" data-modal="title">{{title}}</div><span class="modal__btn-close" data-dismiss="modal" title="Закрыть">×</span></div><div class="modal__body" data-modal="content">{{content}}</div>{{footer}}</div></div>',
            modalFooterTemplate = '<div class="modal__footer">{{buttons}}</div>',
            modalButtonTemplate =
                '<button type="button" class="{{button_class}}" data-handler={{button_handler}}>{{button_text}}</button>',
            modalHTML,
            modalFooterHTML = "";
        elemModal.classList.add("modal");
        modalHTML = modalTemplate.replace(
            "{{title}}",
            options.title || "Новое окно"
        );
        modalHTML = modalHTML.replace("{{content}}", options.content || "");
        if (options.footerButtons) {
            for (var i = 0, length = options.footerButtons.length; i < length; i++) {
                var modalFooterButton = modalButtonTemplate.replace(
                    "{{button_class}}",
                    options.footerButtons[i]["class"]
                );
                modalFooterButton = modalFooterButton.replace(
                    "{{button_handler}}",
                    options.footerButtons[i].handler
                );
                modalFooterButton = modalFooterButton.replace(
                    "{{button_text}}",
                    options.footerButtons[i].text
                );
                modalFooterHTML += modalFooterButton;
            }
            modalFooterHTML = modalFooterTemplate.replace(
                "{{buttons}}",
                modalFooterHTML
            );
        }
        modalHTML = modalHTML.replace("{{footer}}", modalFooterHTML);
        elemModal.innerHTML = modalHTML;
        document.body.appendChild(elemModal);
        return elemModal;
    }

    function _showModal() {
        if (!_destroyed && !_hiding) {
            _elemModal.classList.add("modal__show");
            document.dispatchEvent(_eventShowModal);
        }
    }

    function _hideModal() {
        _hiding = true;
        _elemModal.classList.remove("modal__show");
        _elemModal.classList.add("modal__hiding");
        setTimeout(function () {
            _elemModal.classList.remove("modal__hiding");
            _hiding = false;
        }, _animationSpeed);
        document.dispatchEvent(_eventHideModal);
    }

    function _handlerCloseModal(e) {
        if (e.target.dataset.dismiss === "modal") {
            _hideModal();
        }
    }

    _elemModal = _createModal(options || {});
    _elemModal.addEventListener("click", _handlerCloseModal);
    _eventShowModal = new CustomEvent("show.modal", {
        detail: _elemModal,
    });
    _eventHideModal = new CustomEvent("hide.modal", {
        detail: _elemModal,
    });
    return {
        show: _showModal,
        hide: _hideModal,
        destroy: function destroy() {
            _elemModal.parentElement.removeChild(_elemModal),
                _elemModal.removeEventListener("click", _handlerCloseModal),
                (_destroyed = true);
        },
        setContent: function setContent(html) {
            _elemModal.querySelector('[data-modal="content"]').innerHTML = html;
        },
        setTitle: function setTitle(text) {
            _elemModal.querySelector('[data-modal="title"]').innerHTML = text;
        },
    };
};

/**
 * Работа с цветами
 */

var price0375 = document.querySelector('.js-price-value-0375');
var price075 = document.querySelector('.js-price-value-075');
var price2 = document.querySelector('.js-price-value-2');
var price10 = document.querySelector('.js-price-value-10');

var basePrice0375 = (price0375) ? Number(price0375.textContent.trim()) : '';
var basePrice075 = (price075) ? Number(price075.textContent.trim()) : '';
var basePrice2 = (price2) ? Number(price2.textContent.trim()) : '';
var basePrice10 = (price10) ? Number(price10.textContent.trim()) : '';

/*if (typeof window.color_html != 'undefined') {
    var color_html = '';
}*/
if (typeof color_html == "undefined") {
    var color_html = "";
}
var modal = $modal({
    title: "Выбор цвета",
    content: color_html,
});
var el_color_select = document.getElementById("color_select");
if (el_color_select != null) {
    el_color_select.addEventListener("click", function (e) {
        /*document.body.style.overflow = 'hidden';*/
        modal.show();
    });
}
/*document.querySelector('.modal__btn-close').addEventListener('click', function(e) {
    document.body.style.overflow = 'auto';
});*/

document.querySelectorAll(".item-color").forEach(function (elem) {
    elem.addEventListener("click", function (e) {

        var nameColor = elem.querySelector('.name-color');
        el_color_select.value = nameColor.textContent;

        document.querySelectorAll(".item-color").forEach(function (elem) {
            elem.classList.remove("selected");
        });
        var colorPrice0375 = this.getAttribute('data-price-0375');
        var colorPrice075 = this.getAttribute('data-price-075');
        var colorPrice2 = this.getAttribute('data-price-2');
        var colorPrice10 = this.getAttribute('data-price-10');

        if (price0375) {
            price0375.textContent = basePrice0375 + Number(colorPrice0375);
        }

        if (price075) {
            price075.textContent = basePrice075 + Number(colorPrice075);
        }

        if (price2) {
            price2.textContent = basePrice2 + Number(colorPrice2);
        }

        if (price10) {
            price10.textContent = basePrice10 + Number(colorPrice10);
        }

        var url_img = this.querySelector("img").getAttribute("src");
        var sku_img = this.querySelector("img").getAttribute("alt");
        this.classList.add("selected");
        document.getElementById("color_selected_form").querySelector("img").setAttribute("src", url_img);
        document.getElementById("color_selected_form").querySelector("img").setAttribute("alt", sku_img);
        document.getElementById("color_selected_form").querySelector(".name-color").innerHTML = sku_img;
    });
});

var el_btn_select_color = document.getElementById("btn_select_color");
if (el_btn_select_color != null) {
    el_btn_select_color.addEventListener("click", function (e) {
        var sku = document.getElementById("color_selected_form").querySelector("img").getAttribute("alt");
        var sku_tin = document.getElementById("color_selected_form").querySelector("img").getAttribute("data-tinting");
        var sku_tin_ar = {
            1: {
                0.2: 38,
                0.375: 75,
                0.75: 145,
                0.8: 152,
                0.9: 171,
                2: 380,
                2.25: 427,
                2.5: 475,
                5: 950,
                9: 1710,
                10: 1900,
            },
            2: {
                0.2: 90,
                0.375: 170,
                0.75: 340,
                0.8: 360,
                0.9: 405,
                2: 900,
                2.25: 1012,
                2.5: 1125,
                5: 2250,
                9: 4050,
                10: 4500,
            },
            3: {
                0.2: 120,
                0.375: 225,
                0.75: 470,
                0.8: 480,
                0.9: 540,
                2: 1200,
                2.25: 1350,
                2.5: 1500,
                5: 3000,
                9: 5400,
                10: 6000,
            },
        };
        // document.getElementById("color_select").value = sku;
        // var obj = sku_tin_ar[sku_tin];
        // Object.entries(obj).forEach(function (key, value) {
        //     if (
        //         document.querySelector('span[data-pricesq="' + key[0] + '"]') !== null
        //     ) {
        //         var price = parseInt(
        //             document
        //                 .querySelector('span[data-pricesq="' + key[0] + '"]')
        //                 .getAttribute("data-cost")
        //         );
        //         document.querySelector(
        //             'span[data-pricesq="' + key[0] + '"] > span'
        //         ).textContent = price + key[1];
        //     }
        // });
        calc();
        modal.hide();
    });
}

/*==========================================================================================================================================================================*/
/* Проверка устройства, на котором открыта страница */
var isMobile = {
    Android: function Android() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    },
};

function isIE() {
    ua = navigator.userAgent;
    var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    return is_ie;
}

if (isIE()) {
    document.querySelector("body").classList.add("ie");
}
if (isMobile.any()) {
    document.querySelector("body").classList.add("_touch");
}

function testWebP(callback) {
    var webP = new Image();
    webP.onload = webP.onerror = function () {
        callback(webP.height == 2);
    };
    webP.src =
        "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
}

testWebP(function (support) {
    if (support == true) {
        document.querySelector("body").classList.add("_webp");
    } else {
        document.querySelector("body").classList.add("_no-webp");
    }
});

function calc() {
    var input = parseFloat(document.querySelector("#area_input").value);
    var item_prices = document.querySelectorAll("[data-pricesq]");
    var prices = [];
    item_prices.forEach(function (item, index) {
        if (item.textContent && item.dataset.pricesq) {
            prices.push({
                square: item.dataset.pricesq,
                price: parseFloat(item.textContent.replace(/[^\d,\.]/g, "")),
            });
        }
    });
    if (prices.length == 0) {
        return;
    }
    document
        .querySelectorAll(".data-product__data-rate")
        .forEach(function (block, i) {
            i++;
            var out_layer = document.getElementById("out_layer_" + i);
            if (
                out_layer &&
                _typeof(out_layer) !== null &&
                out_layer !== "undefined" &&
                input > 0
            ) {
                var out_layer = out_layer.textContent;
                var volume = 0;
                out_layer = parseFloat(out_layer.replace(/[^\d,\.]/g, ""));
                volume = input / out_layer;
                volume = Math.round(volume * 100) / 100;

                //вычисление кол-ва банок
                var remainder = volume;
                var jars = [];
                var jars_result = "";
                var jars_price = 0;
                while (remainder > 0) {
                    var index_last = prices.length - 1;
                    var _iterator = _createForOfIteratorHelper(prices.entries()),
                        _step;
                    try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            var _step$value = _slicedToArray(_step.value, 2),
                                index = _step$value[0],
                                item = _step$value[1];
                            if (remainder <= item.square || index_last == index) {
                                remainder = remainder - item.square;
                                jars_price = jars_price + item.price;
                                jars.push(item.square);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally {
                        _iterator.f();
                    }
                }
                jars = jars.reduce(function (acc, el) {
                    acc[el] = (acc[el] || 0) + 1;
                    return acc;
                }, {});
                Object.entries(jars).forEach(function (entry) {
                    var _entry = _slicedToArray(entry, 2),
                        key = _entry[0],
                        value = _entry[1];
                    if (jars_result) jars_result += " и ";
                    jars_result += value + " банок по " + key + " л";
                });

                // стоимость за 1м
                var price_metr = Math.round(jars_price / input);

                // обновление результатов
                document.getElementById("volume_" + i).textContent = volume + " л";
                document.getElementById("jar_" + i).textContent = jars_result;
                document.getElementById("price_metr_" + i).textContent =
                    price_metr + " Р";
            } else {
                //очистить
                document.getElementById("volume_" + i).textContent = "";
                document.getElementById("jar_" + i).textContent = "";
                document.getElementById("price_metr_" + i).textContent = "";
            }
        });
}

/*==========================================================================================================================================================================*/
/* Menu Burger */
var iconMenu = document.querySelector(".header__menu-icon");
var unlock = true;
if (iconMenu != null) {
    var _delay = 500;
    var menuBody = document.querySelector(".header__bottom");
    iconMenu.addEventListener("click", function (e) {
        if (unlock) {
            bodyLock(_delay);
            iconMenu.classList.toggle("_active");
            menuBody.classList.toggle("_active");
            document.documentElement.classList.toggle("_menu-open");
        }
    });
}

function menuToggle() {
    var iconMenu = document.querySelector(".header__menu-icon");
    if (iconMenu != null) {
        var _menuBody = document.querySelector(".header__bottom");
        if (unlock) {
            bodyLock((delay = 500));
            iconMenu.classList.toggle("_active");
            _menuBody.classList.toggle("_active");
            document.documentElement.classList.toggle("_menu-open");
        }
    }
}

function bodyLock(delay) {
    var body = document.querySelector("body");
    if (body.classList.contains("_lock")) {
        bodyLockRemove(delay);
    } else {
        bodyLockAdd(delay);
    }
}

function bodyLockRemove(delay) {
    var body = document.querySelector("body");
    if (unlock) {
        var _lockPadding = document.querySelectorAll("._lp");
        setTimeout(function () {
            for (var index = 0; index < _lockPadding.length; index++) {
                var el = _lockPadding[index];
                el.style.paddingRight = "0px";
            }
            body.style.paddingRight = "0px";
            body.classList.remove("_lock");
        }, delay);
        unlock = false;
        setTimeout(function () {
            unlock = true;
        }, delay);
    }
}

function bodyLockAdd(delay) {
    var body = document.querySelector("body");
    if (unlock) {
        var _lockPadding2 = document.querySelectorAll("._lp");
        for (var index = 0; index < _lockPadding2.length; index++) {
            var el = _lockPadding2[index];
            el.style.paddingRight =
                window.innerWidth -
                document.querySelector(".wrapper").offsetWidth +
                "px";
        }
        body.style.paddingRight =
            window.innerWidth - document.querySelector(".wrapper").offsetWidth + "px";
        body.classList.add("_lock");
        unlock = false;
        setTimeout(function () {
            unlock = true;
        }, delay);
    }
}

/*==========================================================================================================================================================================*/
/* Кнопка "Вверх" */
if (document.querySelector(".content").classList.contains("_main-page")) {
    var showButton = function showButton() {
        var buttonUp = document.querySelector(".button-video");
        if (buttonUp && window.pageYOffset > 200) {
            buttonUp.classList.add("_active");
        }
    };
    window.addEventListener("scroll", showButton);
}

/*==========================================================================================================================================================================*/
/* Плавная прокрутка к блоку */
var menuLinks = document.querySelectorAll("[data-goto]");
if (menuLinks) {
    menuLinks.forEach(function (elem) {
        elem.addEventListener("click", gotoBlock);
    });
}

function gotoBlock(e) {
    var targetBlock = e.target.getAttribute("data-goto");
    var targetBlockElement = document.querySelector(targetBlock);
    removeActiveClasses(menuLinks, "_active");
    e.target.classList.add("_active");
    if (targetBlockElement) {
        // Закрытие открытого меню:
        document.documentElement.classList.contains("_menu-open")
            ? menuToggle()
            : null;

        // Прокрутка:
        var headerBlockHeight = document.querySelector(".header").offsetHeight;
        window.scrollTo({
            top: targetBlockElement.getBoundingClientRect().top + window.scrollY,
            behavior: "smooth",
        });
        e.preventDefault();
    } else {
        if (!document.querySelector("._main")) {
            console.log(
                "[gotoBlock]: \u0422\u0430\u043A\u043E\u0433\u043E \u0431\u043B\u043E\u043A\u0430 \u043D\u0435\u0442 \u043D\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 (".concat(
                    targetBlock,
                    ") \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435, \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0438\u043C \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
                )
            );
            location.href = "/#".concat(targetBlock);
        } else {
            console.log(
                "[gotoBlock]: \u0422\u0430\u043A\u043E\u0433\u043E \u0431\u043B\u043E\u043A\u0430 \u043D\u0435\u0442 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435: ".concat(
                    targetBlock
                )
            );
        }
    }
}

function removeActiveClasses(array, className) {
    for (var i = 0; i < array.length; i++) {
        array[i].classList.remove(className);
    }
}

/*==========================================================================================================================================================================*/

/* Табы */
function tabs() {
    var tabs = document.querySelectorAll("[data-tabs]");
    var tabsActiveHash = [];
    if (tabs.length > 0) {
        var hash = location.hash.replace("#", "");
        if (hash.startsWith("tab-")) {
            tabsActiveHash = hash.replace("tab-", "").split("-");
        }
        tabs.forEach(function (tabsBlock, index) {
            tabsBlock.classList.add("_tab-init");
            tabsBlock.setAttribute("data-tabs-index", index);
            tabsBlock.addEventListener("click", setTabsAction);
            initTabs(tabsBlock);
        });

        // Получение табов с медиа запросами:
        var tabsMedia = Array.from(tabs).filter(function (item, index, self) {
            return item.dataset.tabs;
        });
        // Инициализация табов с медиа запросами:
        if (tabsMedia.length > 0) {
            initMediaTabs(tabsMedia);
        }
    }

    // Инициализация табов с медиа запросами:
    function initMediaTabs(tabsMedia) {
        var breakpointsArray = [];
        tabsMedia.forEach(function (item) {
            var breakpointValue = item.dataset.tabs;
            var tabsBreakpointsObject = {};
            tabsBreakpointsObject.value = breakpointValue;
            tabsBreakpointsObject.item = item;
            breakpointsArray.push(tabsBreakpointsObject);
        });

        // Получаем уникальные брейкпоинты:
        var mediaQueries = breakpointsArray.map(function (item) {
            return "(max-width:".concat(item.value, "px),").concat(item.value);
        });
        mediaQueries = mediaQueries.filter(function (item, index, self) {
            return self.indexOf(item) === index;
        });

        // Работаем с каждым брейкпоинтом:
        mediaQueries.forEach(function (breakpoint) {
            var paramsArray = breakpoint.split(",");
            var matchMedia = window.matchMedia(paramsArray[0]);
            var mediaBreakpoint = paramsArray[1];
            // Объекты с нужными условиями:
            var tabsMediaArray = breakpointsArray.filter(function (item) {
                if (item.value === mediaBreakpoint) {
                    return true;
                }
            });

            // Событие:
            matchMedia.addEventListener("change", function () {
                setTitlePosition(tabsMediaArray, matchMedia);
            });
            setTitlePosition(tabsMediaArray, matchMedia);
        });
    }

    // Установка позиций заголовков:
    function setTitlePosition(tabsMediaArray, matchMedia) {
        tabsMediaArray.forEach(function (tabsMediaItem) {
            tabsMediaItem = tabsMediaItem.item;
            var tabsTitles = tabsMediaItem.querySelector("[data-tabs-titles]");
            var tabsTitleItems = tabsMediaItem.querySelectorAll("[data-tabs-title]");
            var tabsContent = tabsMediaItem.querySelector("[data-tabs-body]");
            var tabsContentItems = tabsMediaItem.querySelectorAll("[data-tabs-item]");
            tabsContentItems.forEach(function (tabsContentItem, index) {
                if (matchMedia.matches) {
                    tabsContent.append(tabsTitleItems[index]);
                    tabsContent.append(tabsContentItem);
                    tabsMediaItem.classList.add("_tab-spoller");
                } else {
                    tabsTitles.append(tabsTitleItems[index]);
                    tabsMediaItem.classList.remove("_tab-spoller");
                }
            });
        });
    }

    // Работа с контентом:
    function initTabs(tabsBlock) {
        // 		console.log('initTabs', tabsBlock)
        var tabsTitles = tabsBlock.querySelectorAll("[data-tabs-titles]>*");
        // 		console.log('tabsTitles', tabsTitles);
        var tabsContent = tabsBlock.querySelectorAll("[data-tabs-body]>*");
        var tabsBlockIndex = tabsBlock.dataset.tabsIndex;
        var tabsActiveHashBlock = tabsActiveHash[0] == tabsBlockIndex;
        if (tabsActiveHashBlock) {
            var tabsActiveTitle = tabsBlock.querySelector(
                "[data-tabs-titles]>._tab-active"
            );
            tabsActiveTitle.classList.remove("_tab-active");
        }
        if (tabsContent.length > 0) {
            // 			console.log('tabsContent.length', tabsContent.length);
            tabsContent.forEach(function (tabsContentItem, index) {
                tabsTitles[index].setAttribute("data-tabs-title", "");
                tabsContentItem.setAttribute("data-tabs-item", "");
                if (tabsActiveHashBlock && index == tabsActiveHash[1]) {
                    tabsTitles[index].classList.add("_tab-active");
                }
                tabsContentItem.hidden =
                    !tabsTitles[index].classList.contains("_tab-active");
            });
        }
    }

    function setTabsStatus(tabsBlock) {
        var tabsTitles = tabsBlock.querySelectorAll("[data-tabs-title]");
        var tabsContent = tabsBlock.querySelectorAll("[data-tabs-item]");
        var tabsBlockIndex = tabsBlock.dataset.tabsIndex;

        function isTabsAnamate(tabsBlock) {
            if (tabsBlock.hasAttribute("data-tabs-animate")) {
                return tabsBlock.dataset.tabsAnimate > 0
                    ? tabsBlock.dataset.tabsAnimate
                    : 500;
            }
        }

        var tabsBlockAnimate = isTabsAnamate(tabsBlock);
        if (tabsContent.length > 0) {
            tabsContent.forEach(function (tabsContentItem, index) {
                if (tabsTitles[index].classList.contains("_tab-active")) {
                    if (tabsBlockAnimate) {
                        _slideDown(tabsContentItem, tabsBlockAnimate);
                    } else {
                        tabsContentItem.hidden = false;
                    }
                    location.hash = "tab-".concat(tabsBlockIndex, "-").concat(index);
                } else {
                    if (tabsBlockAnimate) {
                        _slideUp(tabsContentItem, tabsBlockAnimate);
                    } else {
                        tabsContentItem.hidden = true;
                    }
                }
            });
        }
    }

    function setTabsAction(e) {
        var el = e.target;
        if (el.closest("[data-tabs-title]")) {
            var tabTitle = el.closest("[data-tabs-title]");
            var tabsBlock = tabTitle.closest("[data-tabs]");
            if (
                !tabTitle.classList.contains("_tab-active") &&
                !tabsBlock.querySelectorAll("._slide").length
            ) {
                var tabActiveTitle = tabsBlock.querySelector(
                    "[data-tabs-title]._tab-active"
                );
                if (tabActiveTitle) {
                    tabActiveTitle.classList.remove("_tab-active");
                }
                tabTitle.classList.add("_tab-active");
                setTabsStatus(tabsBlock);
            }
            e.preventDefault();
        }
    }
}

tabs();

/*==========================================================================================================================================================================*/
/* Функции Анимации */
var _slideUp = function _slideUp(target) {
    var duration =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(function () {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
        target.classList.remove("_slide");
    }, duration);
};
var _slideDown = function _slideDown(target) {
    var duration =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    target.style.removeProperty("display");
    var display = window.getComputedStyle(target).display;
    if (display === "none") display = "block";
    target.style.display = display;
    var height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(function () {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
        target.classList.remove("_slide");
    }, duration);
};
var _slideToggle = function _slideToggle(target) {
    var duration =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    if (!target.classList.contains("_slide")) {
        target.classList.add("_slide");
        if (window.getComputedStyle(target).display === "none") {
            return _slideDown(target, duration);
        } else {
            return _slideUp(target, duration);
        }
    }
};

/*==========================================================================================================================================================================*/
/* Slider Swiper */
window.onload = function () {
    function bildSliders() {
        var sliders = document.querySelectorAll(
            '[class*="__wrapper"]:not(.swiper-wrapper)'
        );
        if (sliders) {
            sliders.forEach(function (slider) {
                slider.parentElement.classList.add("swiper");
                slider.classList.add("swiper-wrapper");
                var _iterator2 = _createForOfIteratorHelper(slider.children),
                    _step2;
                try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var slide = _step2.value;
                        slide.classList.add("swiper-slide");
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally {
                    _iterator2.f();
                }
            });
        }
    }

    bildSliders();

    function initSliders() {
        // Colors. Swiper №1:
        if ((allSliders = document.querySelectorAll(".thumbs-colors__slider"))) {
            // Thumbs:
            allSliders.forEach(function (cSliderElement) {
                var thumbsScandinavianSwiper = new Swiper(cSliderElement, {
                    observer: true,
                    observeParents: true,
                    watchOverflow: true,
                    slidesPerView: "auto",
                    speed: 300,
                });
                new Swiper(
                    cSliderElement.parentNode.parentNode.querySelector(".slider-colors"),
                    {
                        thumbs: {
                            swiper: thumbsScandinavianSwiper,
                        },
                        observer: true,
                        observeParents: true,
                        watchOverflow: true,
                        effect: "fade",
                        slidesPerView: 1,
                        simulateTouch: false,
                        speed: 100,
                        navigation: {
                            nextEl:
                                cSliderElement.parentNode.parentNode.querySelector(
                                    ".swiper-arrow_next"
                                ),
                            prevEl:
                                cSliderElement.parentNode.parentNode.querySelector(
                                    ".swiper-arrow_prev"
                                ),
                        },
                        on: {
                            slideChangeTransitionStart: function slideChangeTransitionStart(
                                swiper
                            ) {
                                var swiperElement = swiper.$el[0];
                                var activeSlide = swiperElement.querySelector(
                                    ".swiper-slide-active"
                                );
                                var activeSlideColorName =
                                    activeSlide.getAttribute("data-name");
                                var activeSlideColorNumber =
                                    activeSlide.getAttribute("data-number");
                                activeSlide
                                    .closest(".tabs-colors__slider")
                                    .previousElementSibling.querySelector(
                                    ".color-info__name"
                                ).innerHTML = activeSlideColorName;
                                activeSlide
                                    .closest(".tabs-colors__slider")
                                    .previousElementSibling.querySelector(
                                    ".color-info__number"
                                ).innerHTML = activeSlideColorNumber;
                            },
                        },
                    }
                );
            });
        }
        if ((allAdvatages = document.querySelectorAll(".slider-advantages"))) {
            allAdvatages.forEach(function (cAdvItem) {
                var advantagesFacadeSwiper = new Swiper(cAdvItem, {
                    observer: true,
                    observeParents: true,
                    watchOverflow: true,
                    effect: "fade",
                    slidesPerView: 1,
                    speed: 350,
                    navigation: {
                        nextEl: cAdvItem.parentNode.querySelector("._swiper-arrow_next"),
                        prevEl: cAdvItem.parentNode.querySelector("._swiper-arrow_prev"),
                    },
                    pagination: {
                        el: cAdvItem.parentNode.querySelector(
                            ".action-advantages__bullets"
                        ),
                        type: "bullets",
                        clickable: true,
                    },
                });
            });
        }

        // Certificate. Swiper:
        if (document.querySelector(".slider-certificate")) {
            var certificateSwiper = new Swiper(".slider-certificate", {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                speed: 800,
                slidesPerView: 4,
                navigation: {
                    nextEl: ".certificate__slider ._swiper-arrow_next",
                    prevEl: ".certificate__slider ._swiper-arrow_prev",
                },
                pagination: {
                    el: ".slider-certificate__bullets",
                    type: "bullets",
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    920: {
                        slidesPerView: 3,
                    },
                    625: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    },
                },
            });
        }

        // Reviews. Swiper:
        if (document.querySelector(".slider-reviews")) {
            var reviewsSwiper = new Swiper(".slider-reviews", {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                spaceBetween: 80,
                slidesPerView: 2,
                autoHeight: false,
                speed: 800,
                navigation: {
                    nextEl: ".reviews__slider ._swiper-arrow_next",
                    prevEl: ".reviews__slider ._swiper-arrow_prev",
                },
                pagination: {
                    el: ".slider-reviews__bullets",
                    type: "bullets",
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 2,
                    },
                    920: {
                        slidesPerView: 2,
                    },
                    625: {
                        slidesPerView: 1,
                    },
                    320: {
                        slidesPerView: 1,
                    },
                },
            });
        }

        // Video. Swiper:
        if (document.querySelector(".slider-video")) {
            var videoSwiper = new Swiper(".slider-video", {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                speed: 800,
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    nextEl: ".video__slider ._swiper-arrow_next",
                    prevEl: ".video__slider ._swiper-arrow_prev",
                },
                pagination: {
                    el: ".slider-video__bullets",
                    type: "bullets",
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 2,
                    },
                    920: {
                        slidesPerView: 2,
                    },
                    625: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    },
                },
            });
        }

        // Product. Swiper:
        if (document.querySelector(".slider-product")) {
            new Swiper(".slider-product", {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                slidesPerView: 1,
                speed: 500,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                    pageUpDown: true,
                },
                navigation: {
                    nextEl: ".info-product__slider .swiper-arrow_next",
                    prevEl: ".info-product__slider .swiper-arrow_prev",
                },
                pagination: {
                    el: ".slider-product-controls__bullets",
                    type: "bullets",
                    clickable: true,
                },
                thumbs: {
                    swiper: {
                        el: ".thumbs-images",
                        slidesPerView: "auto",
                    },
                },
            });
        }
    }

    initSliders();
};

/*==========================================================================================================================================================================*/
/* Маска для телефона */
window.addEventListener("DOMContentLoaded", function () {
    [].forEach.call(document.querySelectorAll("._tel"), function (input) {
        var keyCode;

        function mask(event) {
            event.keyCode && (keyCode = event.keyCode);
            var pos = this.selectionStart;
            if (pos < 3) event.preventDefault();
            var matrix = "+7 (___) ___ ____",
                i = 0,
                def = matrix.replace(/\D/g, ""),
                val = this.value.replace(/\D/g, ""),
                new_value = matrix.replace(/[_\d]/g, function (a) {
                    return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
                });
            i = new_value.indexOf("_");
            if (i != -1) {
                i < 5 && (i = 3);
                new_value = new_value.slice(0, i);
            }
            var reg = matrix
                .substr(0, this.value.length)
                .replace(/_+/g, function (a) {
                    return "\\d{1," + a.length + "}";
                })
                .replace(/[+()]/g, "\\$&");
            reg = new RegExp("^" + reg + "$");
            if (
                !reg.test(this.value) ||
                this.value.length < 5 ||
                (keyCode > 47 && keyCode < 58)
            )
                this.value = new_value;
            if (event.type == "blur" && this.value.length < 5) this.value = "";
        }

        input.addEventListener("input", mask, false);
        input.addEventListener("focus", mask, false);
        input.addEventListener("blur", mask, false);
        input.addEventListener("keydown", mask, false);
    });
});

/*==========================================================================================================================================================================*/
/* Валидация Формы */
var forms = document.querySelectorAll("._form");
var form;
for (var i = 0; i < forms.length; i++) {
    form = forms[i];
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        formSend(this);
    });
}

// Функция проверки и обработки результатов валидации формы:
function formSend(_x2) {
    return _formSend.apply(this, arguments);
} // Функция валидации формы:
function _formSend() {
    _formSend = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee(activeForm) {
            var error,
                formData,
                buttonBack,
                product_calc,
                response,
                result,
                buttonPopup;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1)
                    switch ((_context.prev = _context.next)) {
                        case 0:
                            error = formValidate(activeForm);
                            formData = new FormData(activeForm);
                            if (!(error === 0)) {
                                _context.next = 27;
                                break;
                            }
                            inputRemoveError();

                            // Open Popup Thanks:
                            document.querySelector(".popup-thanks").classList.add("_open");
                            setTimeout(function () {
                                document.body.classList.add("_lock");
                            }, 600);
                            buttonBack = document.querySelector(".popup-thanks__button"); //         console.log(buttonBack);
                            buttonBack.addEventListener("click", function (e) {
                                this.closest(".popup-thanks").classList.remove("_open");
                                setTimeout(function () {
                                    document.body.classList.remove("_lock");
                                }, 100);
                            });
                            if (activeForm.classList.contains("request-product__form")) {
                                product_calc = "";
                                product_calc += document.querySelector(
                                    ".data-product__price"
                                ).innerHTML;
                                product_calc += document.querySelector(
                                    ".data-product__data"
                                ).innerHTML;
                                formData.append("product_calc", product_calc);
                            }
                            _context.next = 11;
                            return fetch("/form.php", {
                                method: "POST",
                                body: formData,
                            });
                        case 11:
                            response = _context.sent;
                            if (!response.ok) {
                                _context.next = 23;
                                break;
                            }
                            _context.next = 15;
                            return response.json();
                        case 15:
                            result = _context.sent;
                            if (result.status) {
                                _context.next = 19;
                                break;
                            }
                            alert(result.message);
                            return _context.abrupt("return");
                        case 19:
                            //             formPreview.innerHTML = "";
                            activeForm.reset();
                            if (document.querySelector(".popup-message")) {
                                document.querySelector(".popup-message").classList.add("_show");
                                buttonPopup = document.querySelector(".popup-message__button");
                                buttonPopup.addEventListener("click", function (e) {
                                    this.closest(".popup-message").classList.remove("_show");
                                });
                            }
                            _context.next = 25;
                            break;
                        case 23:
                            if (activeForm.classList.contains("form-contact__body")) {
                                document
                                    .querySelector(".form-contact__input")
                                    .classList.remove("_error");
                            } else {
                                document
                                    .querySelector(".form-popup__input")
                                    .classList.remove("_error");
                            }
                            alert("Ошибка отправки");
                        case 25:
                            _context.next = 27;
                            break;
                        case 27:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        })
    );
    return _formSend.apply(this, arguments);
}

function formValidate(form) {
    var error = 0;
    var formReq = form.querySelectorAll("._req");
    for (var index = 0; index < formReq.length; index++) {
        var input = formReq[index];
        formRemoveError(input);
        if (input.value === "") {
            formAddError(input);
            error++;
        }
        if (input.getAttribute("type") === "checkbox" && input.checked === false) {
            formAddError(input);
            error++;
        }
    }
    return error;
}

// Функция добавления полю ввода и его родителю класса "_error" (ошибка):
function formAddError(input) {
    input.parentElement.classList.add("_error");
    input.classList.add("_error");
}

// Функция удаления у поля ввода и его родителя класса "_error" (ошибка):
function formRemoveError(input) {
    input.parentElement.classList.remove("_error");
    input.classList.remove("_error");
}

function inputRemoveError() {
    var inputsCases = document.querySelectorAll("._req");
    for (var _i2 = 0; _i2 < inputsCases.length; _i2++) {
        var inputCases = inputsCases[_i2];
        inputCases.classList.remove("_error");
    }
    var inputsPopup = document.querySelectorAll("._req-popup");
    for (var _i3 = 0; _i3 < inputsPopup.length; _i3++) {
        var inputPopup = inputsPopup[_i3];
        inputPopup.classList.remove("_error");
    }
}

/*==========================================================================================================================================================================*/

/* Динамический Адаптив */
function dynamicAdapt(type) {
    this.type = type;
}

// Функция адаптива:
dynamicAdapt.prototype.init = function () {
    var _this2 = this;
    var _this = this;
    this.оbjects = []; // Массив объектов.
    this.daClassname = "_dynamic_adapt_";
    this.nodes = document.querySelectorAll("[data-da]"); // Массив DOM-элементов.
    for (var _i4 = 0; _i4 < this.nodes.length; _i4++) {
        // Наполнение оbjects объктами.
        var node = this.nodes[_i4];
        var data = node.dataset.da.trim();
        var dataArray = data.split(",");
        var оbject = {};
        оbject.element = node;
        оbject.parent = node.parentNode;
        оbject.destination = document.querySelector(dataArray[0].trim());
        оbject.breakpoint = dataArray[1] ? dataArray[1].trim() : "767";
        оbject.place = dataArray[2] ? dataArray[2].trim() : "last";
        оbject.index = this.indexInParent(оbject.parent, оbject.element);
        this.оbjects.push(оbject);
    }
    this.arraySort(this.оbjects);
    this.mediaQueries = Array.prototype.map.call(
        this.оbjects,
        function (item) {
            // Массив уникальных медиа-запросов.
            return (
                "(" +
                this.type +
                "-width: " +
                item.breakpoint +
                "px)," +
                item.breakpoint
            );
        },
        this
    );
    this.mediaQueries = Array.prototype.filter.call(
        this.mediaQueries,
        function (item, index, self) {
            return Array.prototype.indexOf.call(self, item) === index;
        }
    );
    var _loop = function _loop() {
        // Навешивание слушателя на медиа-запрос и вызов обработчика
        var media = _this2.mediaQueries[_i5]; // при первом запуске.
        var mediaSplit = String.prototype.split.call(media, ",");
        var matchMedia = window.matchMedia(mediaSplit[0]);
        var mediaBreakpoint = mediaSplit[1];
        var оbjectsFilter = Array.prototype.filter.call(
            _this2.оbjects,
            function (item) {
                // Массив объектов с подходящим брейкпоинтом.
                return item.breakpoint === mediaBreakpoint;
            }
        );
        matchMedia.addListener(function () {
            _this.mediaHandler(matchMedia, оbjectsFilter);
        });
        _this2.mediaHandler(matchMedia, оbjectsFilter);
    };
    for (var _i5 = 0; _i5 < this.mediaQueries.length; _i5++) {
        _loop();
    }
};

// Функция перемещения:
dynamicAdapt.prototype.mediaHandler = function (matchMedia, оbjects) {
    if (matchMedia.matches) {
        for (var _i6 = 0; _i6 < оbjects.length; _i6++) {
            var оbject = оbjects[_i6];
            оbject.index = this.indexInParent(оbject.parent, оbject.element);
            this.moveTo(оbject.place, оbject.element, оbject.destination);
        }
    } else {
        for (var _i7 = 0; _i7 < оbjects.length; _i7++) {
            var _оbject = оbjects[_i7];
            if (_оbject.element.classList.contains(this.daClassname)) {
                this.moveBack(_оbject.parent, _оbject.element, _оbject.index);
            }
        }
    }
};

// Функция перемещения:
dynamicAdapt.prototype.moveTo = function (place, element, destination) {
    element.classList.add(this.daClassname);
    if (place === "last" || place >= destination.children.length) {
        destination.insertAdjacentElement("beforeend", element);
        return;
    }
    if (place === "first") {
        destination.insertAdjacentElement("afterbegin", element);
        return;
    }
    destination.children[place].insertAdjacentElement("beforebegin", element);
};

// Функция возврата:
dynamicAdapt.prototype.moveBack = function (parent, element, index) {
    element.classList.remove(this.daClassname);
    if (parent.children[index] !== undefined) {
        parent.children[index].insertAdjacentElement("beforebegin", element);
    } else {
        parent.insertAdjacentElement("beforeend", element);
    }
};

// Функция получения индекса внутри родителя:
dynamicAdapt.prototype.indexInParent = function (parent, element) {
    var array = Array.prototype.slice.call(parent.children);
    return Array.prototype.indexOf.call(array, element);
};

// Функция сортировки массива по breakpoint и place по возрастанию для this.type = min по убыванию для this.type = max:
dynamicAdapt.prototype.arraySort = function (arr) {
    if (this.type === "min") {
        Array.prototype.sort.call(arr, function (a, b) {
            if (a.breakpoint === b.breakpoint) {
                if (a.place === b.place) {
                    return 0;
                }
                if (a.place === "first" || b.place === "last") {
                    return -1;
                }
                if (a.place === "last" || b.place === "first") {
                    return 1;
                }
                return a.place - b.place;
            }
            return a.breakpoint - b.breakpoint;
        });
    } else {
        Array.prototype.sort.call(arr, function (a, b) {
            if (a.breakpoint === b.breakpoint) {
                if (a.place === b.place) {
                    return 0;
                }
                if (a.place === "first" || b.place === "last") {
                    return 1;
                }
                if (a.place === "last" || b.place === "first") {
                    return -1;
                }
                return b.place - a.place;
            }
            return b.breakpoint - a.breakpoint;
        });
        return;
    }
};
var da = new dynamicAdapt("max");
da.init();

/*==========================================================================================================================================================================*/
/* Video */
var videos = document.querySelectorAll("._video");
if (videos) {
    for (var item = 0; item < videos.length; item++) {
        var video = videos[item];
        video.addEventListener("click", function (e) {
            if (this.paused) {
                this.play();
                if (this.closest(".popup-video")) {
                    document.querySelector(".popup-video").classList.add("_active");
                    document.querySelector(".popup-video__play").classList.add("_hide");
                }
            } else {
                this.pause();
                if (this.closest(".popup-video")) {
                    document.querySelector(".popup-video").classList.remove("_active");
                    document
                        .querySelector(".popup-video__play")
                        .classList.remove("_hide");
                }
            }
        });
    }
}

/*==========================================================================================================================================================================*/
/* Popup */
var popupLinks = document.querySelectorAll("._popup-link");
var body = document.querySelector("body");
var lockPadding = document.querySelectorAll(".lock-padding");
var timeout = 800;
if (popupLinks.length > 0) {
    var _loop2 = function _loop2() {
        var popupLink = popupLinks[index];
        popupLink.addEventListener("click", function (e) {
            if (popupLink.classList.contains("_popup-link_video")) {
                popupVideo(popupLink);
            }
            unlock = true;
            var popupName = popupLink.getAttribute("href").replace("#", "");
            console.log(popupName);
            var curentPopup = document.getElementById(popupName);
            popupOpen(curentPopup);
            e.preventDefault();
        });
    };
    for (var index = 0; index < popupLinks.length; index++) {
        _loop2();
    }
}
var popupCloseIcon = document.querySelectorAll("._popup-icon");
if (popupCloseIcon.length > 0) {
    var _loop3 = function _loop3() {
        var el = popupCloseIcon[_index];
        el.addEventListener("click", function (e) {
            popupClose(el.closest("._popup"));
            e.preventDefault();
        });
    };
    for (var _index = 0; _index < popupCloseIcon.length; _index++) {
        _loop3();
    }
}

// Открытие popup:
function popupOpen(curentPopup) {
    if (curentPopup && unlock) {
        var popupActive = document.querySelector("._popup._open");
        if (popupActive) {
            popupClose(popupActive, false);
        } else {
            bodyPopupLock();
        }
        curentPopup.classList.add("_open");
        curentPopup.addEventListener("click", function (e) {
            if (!e.target.closest("._popup-content")) {
                popupClose(e.target.closest("._popup"));
            }
        });
    }
}

// Закрытие popup:
function popupClose(popupActive) {
    var doUnlock =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (unlock) {
        popupActive.classList.remove("_open");
        if (doUnlock) {
            bodyUnLock();
        }
    }
}

// Video Popup:
function popupVideo(popupLink) {
    var urlVideo = popupLink.getAttribute("data-video");
    var posterVideo = popupLink
        .querySelector(".video-reviews__poster")
        .getAttribute("src");
    var videoPopup = document.querySelector("#video-popup");
    videoPopup.querySelector("._video").setAttribute("src", urlVideo);
    videoPopup.querySelector("._video").setAttribute("poster", posterVideo);
}

// Блокировка скролла при открытом popup:
function bodyPopupLock() {
    var lockPaddingValue =
        window.innerWidth - document.querySelector(".wrapper").offsetWidth + "px";
    if (lockPadding.length > 0) {
        for (var _index2 = 0; _index2 < lockPadding.length; _index2++) {
            var el = lockPadding[_index2];
            el.style.paddingRight = lockPaddingValue;
        }
    }
    body.style.paddingRight = lockPaddingValue;
    body.classList.add("_lock");
    unlock = false;
    setTimeout(function () {
        unlock = true;
    }, timeout);
}

// Разблокировка скролла при закрытии popup:
function bodyUnLock() {
    setTimeout(function () {
        if (lockPadding.length > 0) {
            for (var _index3 = 0; _index3 < lockPadding.length; _index3++) {
                var el = lockPadding[_index3];
                el.style.paddingRight = "0px";
            }
        }
        body.style.paddingRight = "0px";
        body.classList.remove("_lock");
    }, timeout);
    unlock = false;
    setTimeout(function () {
        unlock = true;
    }, timeout);
}

// Закрытие popup с помощью клавиши "Esc" на клавиатуре:
document.addEventListener("keydown", function (e) {
    if (e.which === 27) {
        var popupActive = document.querySelector("._popup._open");
        popupClose(popupActive);
    }
});

/*==========================================================================================================================================================================*/
/* Input[type=color] */
if (document.querySelector(".content").classList.contains("_product-page")) {
    var inputColor = document.querySelector("input[type=color]");
    if (inputColor) {
        inputColor.addEventListener("input", function (e) {
            inputColor.classList.add("_active");
            var selectColor = this.value;
        });
    }
}

/*==========================================================================================================================================================================*/
/* Полифилы */
(function () {
    if (!Element.prototype.closest) {
        Element.prototype.closest = function (css) {
            var node = this;
            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }
            return null;
        };
    }
})();
(function () {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector;
    }
})();
